import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './styles/OverlaySpinner.scss';

const OverlaySpinner = ({ withDimBackground }) => (
    <div
        className={classnames(styles.spinnerWrapper, {
            [styles.withDimBackground]: withDimBackground,
        })}
    >
        <Spinner dark />
    </div>
);

OverlaySpinner.propTypes = {
    withDimBackground: PropTypes.bool,
};

export default OverlaySpinner;
